import { useEffect, useState } from 'react';

/**
 * Отдаёт значение с задержкой. Нужен полю поиска: без него каждый введённый символ
 * уходит отдельным запросом в API.
 */
export const useDebouncedValue = <T>(value: T, delayMs = 300): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
};
